(function(){
  var THRESH = 8000;
  var dw, itemsEl, shipEl, barEl, totEl;
  function fmt(c){ var s=(c/100).toFixed(3).replace(/0+$/,'').replace(/\.$/,''); return s.replace('.', ',') + ' DT'; }
  function open(){ if(dw){ dw.setAttribute('data-open','1'); document.body.style.overflow='hidden'; } }
  function close(){ if(dw){ dw.setAttribute('data-open','0'); document.body.style.overflow=''; } }
  function change(line, qty){
    return fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function(r){ return r.json(); }).then(render);
  }
  function packName(v){
    if(!v) return '1 Flacon';
    return v.indexOf('3') > -1 ? 'Pack ×3 Intérieur' : '1 Flacon';
  }
  function render(cart){
    if(!itemsEl) return;
    if(!cart.items || !cart.items.length){
      itemsEl.innerHTML = '<p class="dw-empty">Votre panier est vide.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(function(i, n){
        var pack = packName(i.variant_title);
        var sub = pack.indexOf('3') > -1 ? '3 × 500 ml · 🚚 livraison offerte' : '1 × 500 ml';
        return '<div class="dw-i">'
          + '<img src="'+(i.image||'')+'" alt="">'
          + '<div class="dw-c">'
            + '<div class="t">'+pack+'</div>'
            + '<div class="s">Nettoyant Intérieur 3 en 1 — '+sub+'</div>'
            + '<div class="dw-q">'
              + '<button type="button" data-line="'+(n+1)+'" data-qty="'+(i.quantity-1)+'" aria-label="Diminuer">−</button>'
              + '<b>'+i.quantity+'</b>'
              + '<button type="button" data-line="'+(n+1)+'" data-qty="'+(i.quantity+1)+'" aria-label="Augmenter">+</button>'
              + '<button type="button" class="dw-rm" data-line="'+(n+1)+'" data-qty="0">Supprimer</button>'
            + '</div>'
          + '</div>'
          + '<div class="pr">'+fmt(i.line_price)+'</div></div>';
      }).join('');
      itemsEl.querySelectorAll('button[data-line]').forEach(function(b){
        b.addEventListener('click', function(){
          var q = parseInt(b.getAttribute('data-qty'), 10);
          if(isNaN(q) || q < 0) q = 0;
          change(parseInt(b.getAttribute('data-line'), 10), q);
        });
      });
    }
    var t = cart.total_price || 0;
    if(totEl) totEl.textContent = fmt(t);
    if(barEl) barEl.style.width = Math.min(100, Math.round(t/THRESH*100)) + '%';
    if(shipEl) shipEl.innerHTML = t >= THRESH
      ? '🚚 <strong style="color:var(--ink)">Livraison offerte débloquée !</strong>'
      : '🚚 Plus que <strong style="color:var(--ink)">'+fmt(THRESH-t)+'</strong> pour la livraison offerte';
  }
  function refresh(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(render);
  }
  document.addEventListener('DOMContentLoaded', function(){
    if(!/[?&]variant=/.test(location.search)){
      var opts = document.querySelectorAll('.vopt input');
      if(opts.length > 1) opts[opts.length-1].click();
    }
    dw = document.getElementById('lw-drawer');
    if(!dw) return;
    itemsEl = dw.querySelector('.dw-items');
    shipEl = dw.querySelector('.dw-ship-msg');
    barEl = dw.querySelector('.dw-bar span');
    totEl = dw.querySelector('.dw-total-val');
    dw.querySelector('.dw-bg').addEventListener('click', close);
    dw.querySelector('.dw-x').addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(f){
      f.addEventListener('submit', function(e){
        e.preventDefault();
        var btn = f.querySelector('[name="add"]');
        var label = btn ? btn.textContent : '';
        if(btn){ btn.disabled = true; btn.textContent = 'Ajout…'; }
        fetch('/cart/add.js', { method:'POST', body: new FormData(f), headers:{'Accept':'application/json'} })
          .then(function(r){ return r.json(); })
          .then(function(){ refresh(); open(); })
          .catch(function(){ f.submit(); })
          .finally(function(){ if(btn){ btn.disabled = false; btn.textContent = label; } });
      });
    });
    document.querySelectorAll('[data-lw-cart]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); refresh(); open(); });
    });
    refresh();
  });
})();
